import { CopyButton, DetailItem } from '@recargas-dominicanas/core/components';
import type { IAccessToken, ICustomer } from '@recargas-dominicanas/core/types';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './customer-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  customer: ICustomer;
  onClose: () => void;
}

export function CustomerModal(props: Props) {

  const { open, title, customer, onClose } = props;
  
  const accessToken = customer.user.accessToken;
  const link = `${process.env.APP_CUSTOMER_DOMAIN}/cambiar-contraseña/${accessToken?.token}`;

  function expired(accessToken: IAccessToken) {
    return Date.parse(accessToken.expirationDate) < Date.now();
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title={title}
      secondaryButton='Aceptar'
      onClose={onClose}
      onSecondaryClick={onClose}>
      <DetailItem
        style={style.detailItem}
        title='Nombre'
        weight='medium'
        text={customer.name}/>
      {customer.username &&
        <DetailItem
          style={style.detailItem}
          title='Usuario'
          weight='medium'
          text={customer.username}/>
      }
      {accessToken && !expired(accessToken) &&
        <div className={style.linkSection}>
          <div className={style.linkHeader}>
            <span className={style.linkTitle}>Enlace</span>
          </div>
          <div className={style.linkRow}>
            <span className={style.link}>{link}</span>
            <CopyButton className={style.copyButton} text={link}/>
          </div>
        </div>
      }
    </Modal>
  );
}
